module.exports = __webpack_public_path__ + "img/62 (1).329fe563.png";